<mat-card appearance="outlined" *ngIf="headerForm">
  <mat-card-header>
    <mat-card-title>
      {{ 'COMMON.ORDER_DETAILS.TITLE' | translate }}
      <div *ngIf="isUpdating$ | async">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="headerForm" class="cols">
      <!-- company and address -->
      <div class="key-val-group">
        <span class="key">
          {{ 'COMMON.ORDER_DETAILS.COMPANY_AND_ADDRESS' | translate }}
        </span>
        <span class="val name">
          <a [routerLink]="'/info/' + business?.accountGroupId">
            {{ business?.napData?.companyName }}
          </a>
        </span>
        <ng-container *ngIf="business?.napData">
          <span class="val address">
            <div>
              {{ address | glxyAddress }}
            </div>
          </span>
        </ng-container>
      </div>

      <!-- start -->
      <div class="key-val-group">
        <span class="key" matTooltip="{{ 'SALES_ORDERS.CONTRACT_START_HINT' | translate }}" matTooltipPosition="above">
          {{ 'COMMON.ORDER_DETAILS.CONTRACT_START' | translate }}
        </span>
        <glxy-form-field class="val date-picker" [showLabel]="false" [size]="'small'">
          <input dense matInput formControlName="contractStartDate" [min]="minDate" [matDatepicker]="picker" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="contractStartControl.hasError('required')">
            {{ 'COMMON.ORDERS.REQUIRED' | translate }}
          </mat-error>
        </glxy-form-field>
      </div>

      <!-- duration -->
      <div class="key-val-group">
        <span class="key" matTooltip="{{ 'SALES_CONTRACT_DURATION.HINT' | translate }}" matTooltipPosition="above">
          {{ 'COMMON.ORDER_DETAILS.CONTRACT_DURATION' | translate }}
        </span>
        <span class="val contract-duration" formGroupName="contractDuration">
          <ng-container
            *ngIf="contractDuration || createMode || editingDuration || contractDuration; else noContractDuration"
          >
            <glxy-form-field class="duration-value" [showLabel]="false" [size]="'small'" [bottomSpacing]="'none'">
              <input matInput type="number" class="duration-value" min="1" formControlName="value" />
              <mat-error *ngIf="contractDurationValueControl.hasError('min')" style>
                {{ 'COMMON.ORDERS.ERROR_LESS_THAN_ONE' | translate }}
              </mat-error>
            </glxy-form-field>
            <glxy-form-field class="duration-period" [showLabel]="false" [size]="'small'" [bottomSpacing]="'none'">
              <mat-select formControlName="duration">
                <mat-option
                  *ngFor="let option of periodOptions"
                  [value]="option.value"
                  class="contract-duration-option"
                >
                  {{ option.label | translate }}
                </mat-option>
              </mat-select>
            </glxy-form-field>
          </ng-container>

          <ng-template #noContractDuration>
            <span>{{ 'COMMON.ORDER_DETAILS.NO_CONTRACT_DURATION' | translate }}</span>
            <button mat-icon-button *ngIf="!editingDisabled" (click)="showEditableDuration()" class="small-icon">
              <mat-icon>edit</mat-icon>
            </button>
          </ng-template>
        </span>
      </div>
    </form>
  </mat-card-content>
</mat-card>
